import React, { useState, useEffect } from "react";
import Parse from "parse";
import moment from "moment-with-locales-es6";
import { Bar, Doughnut } from "react-chartjs-2";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { useNavigate } from "react-router-dom";
import { Box } from "@chakra-ui/react";
import {
  Chart as ChartJS,
  BarElement,
  LinearScale,
  CategoryScale,
  ArcElement,
  Tooltip,
  Legend,
} from "chart.js";

ChartJS.register(ArcElement, Tooltip, Legend);

ChartJS.register(BarElement, LinearScale, CategoryScale);

const MatchedUserParSecteur = () => {
  ////////////////////////////////////////////////////////////////

  moment.locale("fr");

  useEffect(() => {}, []);

  const navigate = useNavigate();
  const [eventsSlider, setEventsSlider] = useState([]);

  const [labelsMatch, setLabelsMatch] = useState([]);
  const [dataMatch, setDataMatch] = useState([]);

  async function fetchEvent() {
    const currentUser = Parse.User.current();

    const Match = Parse.Object.extend("Match");
    const query1 = new Parse.Query(Match);
    query1.equalTo("user1", currentUser);
    query1.greaterThanOrEqualTo(
      "createdAt",
      moment().locale("fr").subtract(180, "days").startOf("month").toDate()
    );
    query1.ascending("createdAt");

    const query2 = new Parse.Query(Match);
    query2.equalTo("user2", currentUser);
    query2.greaterThanOrEqualTo(
      "createdAt",
      moment().locale("fr").subtract(180, "days").startOf("month").toDate()
    );
    query2.ascending("createdAt");

    const mainQuery = Parse.Query.or(query1, query2);
    const match = await mainQuery.find().catch((error) => {
      alert(
        "Failed to update user informations, with error code: " + error.message
      );
      Parse.User.logOut();
      navigate("/");
    });

    const tempData = [];
    if (match !== undefined) {
      for (let i = 0; i < match.length; i++) {
        tempData.push({
          id: match[i].id,
          city: match[i].get("city"),
          date: match[i].get("createdAt").toString(),
          postalCode: match[i].get("postalCode"),
          secteur: match[i].get("secteur"),
        });
      }

      var eventsParMois = new Map();
      tempData.map((e) => {
        var month = moment(e.date);
        var monthNumber = month.month();
        var eventsOfMonthTable = eventsParMois.get(monthNumber);
        if (!eventsOfMonthTable) {
          eventsOfMonthTable = [];
        }
        eventsOfMonthTable.push(e);
        eventsParMois.set(monthNumber, eventsOfMonthTable);
      });

      setEventsSlider(eventsParMois);

      setRawData(eventsParMois);

      moment.locale("fr");

      const labels = [];
      const data = [];

      var matchParMois = new Map();
      eventsParMois.forEach((value, key) => {
        labels.push(moment.months(key));
        data.push(value.length);
        var currMonth = moment.months(key);
        var matchsOfMonthTable = matchParMois.get(currMonth);

        if (!matchsOfMonthTable) {
          matchsOfMonthTable = new Map();
        }

        value.forEach((element) => {
          var x = matchsOfMonthTable.get(element.secteur);
          if (!x) {
            x = 0;
          }
          x++;
          matchsOfMonthTable.set(element.secteur, x);
        });

        matchParMois.set(currMonth, matchsOfMonthTable);
        //matchsOfMonthTable.push();
      });

      setMatchsPM(matchParMois);

      setLabelsMatch(labels);
      setDataMatch(data);

      const temp = [];
      temp.push(labels);
      temp.push(data);
      setMatchs(temp);
    }
    return match;
  }

  useEffect(() => {
    fetchEvent();
  }, []);

  ////////////////////////////////////////////////////////////////

  const [matchs, setMatchs] = useState([]);
  const [rawData, setRawData] = useState([]);
  const [matchsPM, setMatchsPM] = useState([]);

  var options = {
    responsive: true,
    scales: {
      y: {
        beginAtZero: true,
        stacked: true,
        grid: {
          display: false,
        },
        ticks: {
          mirror: true,
        },
      },
      x: {
        beginAtZero: true,
        stacked: true,
        grid: {
          display: false,
        },
      },
    },
  };

  const settings = {
    dots: false,
    infinite: false,
    speed: 1000,
    slidesToShow: 1,
    arrows: false,
    slidesToScroll: 1,
  };

  return (
    <Slider {...settings} className="matched-user-par-secteur">
      {labelsMatch.map(function (value, key) {
        return (
          <div key={key}>
            <h3>{value}</h3>
            <Box
              bg="white"
              padding={"15px"}
              h={"max-content"}
              w="80%"
              margin={"10px"}
              borderRadius={"20px"}
            >
              <Doughnut
                data={{
                  labels: Array.from(matchsPM.get(value).keys()),
                  datasets: [
                    {
                      label: "# of Votes",
                      data: Array.from(matchsPM.get(value).values()),
                      backgroundColor: [
                        "rgba(255, 99, 132, 0.2)",
                        "rgba(54, 162, 235, 0.2)",
                        "rgba(255, 206, 86, 0.2)",
                        "rgba(75, 192, 192, 0.2)",
                        "rgba(153, 102, 255, 0.2)",
                        "rgba(255, 159, 64, 0.2)",
                      ],
                      borderColor: [
                        "rgba(255, 99, 132, 1)",
                        "rgba(54, 162, 235, 1)",
                        "rgba(255, 206, 86, 1)",
                        "rgba(75, 192, 192, 1)",
                        "rgba(153, 102, 255, 1)",
                        "rgba(255, 159, 64, 1)",
                      ],
                      borderWidth: 1,
                    },
                  ],
                }}
              />
            </Box>
          </div>
        );
      })}
    </Slider>
  );
};

export default MatchedUserParSecteur;
